// extracted by mini-css-extract-plugin
export var deleteIcon = "_os-5";
export var deleteOption = "_os-3";
export var divider = "_os-2";
export var downloadIcon = "_os-4";
export var drawer = "_os-0";
export var drawerFooter = "_os-6";
export var drawerOpen = "_os-1";
export var highlighted = "_os-7";
export var lighterHighlight = "_os-8";